<p>{{ totalStock$ | async }}</p>
